import { useContext } from "react";
import { langContext } from "../api/Lang";

const el = {
    howItWorksTitle: "Πώς λειτουργεί",
    howItWorksSubtitle: "Παράγγειλε φαγητό στο σχολείο, εύκολα και γρήγορα!",
    signInWithGoogle: "Σύνδεση μέσω Google",
    continueWithEmail: "Σύνδεση μέσω ηλεκτρονικού ταχυδρομείου",
    emailLabel: "Email",
    passwordLabel: "Κωδικός πρόσβασης",
    confirmPasswordLabel: "Επιβεβαίωση κωδικού",
    next: "Επόμενο",
    signIn: "Σύνδεση",
    signUp: "Εγγραφή",
    createAccount: "Δημιουργία λογαριασμού",
    forgotPassword: "Ξέχασες τον κωδικό;",
    sendResetLink: "Αποστολή συνδέσμου",
    saveNewPassword: "Αποθήκευση νέου κωδικού",
    back: "Πίσω",
    or: "ή",
    tosPrefix: "Αν συνεχίσετε, δηλώνετε ότι αποδέχεστε τους",
    tosLink: "Όρους Παροχής Υπηρεσιών",
    tosAnd: "και την",
    privacyLink: "Πολιτική απορρήτου",
    resetEmailSent: "Σου στείλαμε email με οδηγίες για επαναφορά του κωδικού.",
    passwordChanged: "Ο κωδικός σου άλλαξε. Μπορείς να συνδεθείς.",
    emailVerified: "Το email σου επαληθεύτηκε. Μπορείς να συνδεθείς.",
    passwordsDoNotMatch: "Οι κωδικοί δεν ταιριάζουν.",
    genericError: "Κάτι πήγε στραβά. Δοκίμασε ξανά.",
    // Firebase auth error codes
    authWrongPassword: "Λάθος κωδικός πρόσβασης.",
    authUserNotFound: "Δεν βρέθηκε λογαριασμός με αυτό το email.",
    authEmailAlreadyInUse: "Αυτό το email χρησιμοποιείται ήδη.",
    authWeakPassword: "Ο κωδικός είναι πολύ αδύναμος. Χρησιμοποίησε τουλάχιστον 6 χαρακτήρες.",
    authTooManyRequests: "Πάρα πολλές προσπάθειες. Δοκίμασε ξανά αργότερα.",
    authPopupClosed: "Η σύνδεση ακυρώθηκε.",
    authAccountExistsDifferentProvider: "Αυτό το email είναι συνδεδεμένο με Google. Συνδέσου με Google.",
    authInvalidEmail: "Μη έγκυρο email.",
    authInvalidActionCode: "Ο σύνδεσμος δεν είναι έγκυρος ή έχει λήξει.",
    authNetworkError: "Σφάλμα δικτύου. Έλεγξε τη σύνδεσή σου.",
    authUserDisabled: "Αυτός ο λογαριασμός έχει απενεργοποιηθεί.",
    authOperationNotAllowed: "Αυτή η μέθοδος σύνδεσης δεν είναι διαθέσιμη.",
    authCredentialAlreadyInUse: "Αυτά τα στοιχεία σύνδεσης χρησιμοποιούνται ήδη.",
};

const en: typeof el = {
    howItWorksTitle: "How it works",
    howItWorksSubtitle: "Order food at school, easily and quickly!",
    signInWithGoogle: "Sign in with Google",
    continueWithEmail: "Sign in with email",
    emailLabel: "Email",
    passwordLabel: "Password",
    confirmPasswordLabel: "Confirm password",
    next: "Next",
    signIn: "Sign in",
    signUp: "Sign up",
    createAccount: "Create account",
    forgotPassword: "Forgot your password?",
    sendResetLink: "Send reset link",
    saveNewPassword: "Save new password",
    back: "Back",
    or: "or",
    tosPrefix: "By continuing, you indicate that you accept the",
    tosLink: "Terms of Service",
    tosAnd: "and",
    privacyLink: "Privacy Policy",
    resetEmailSent: "We sent you an email with instructions to reset your password.",
    passwordChanged: "Your password was changed. You can sign in now.",
    emailVerified: "Your email was verified. You can sign in now.",
    passwordsDoNotMatch: "Passwords do not match.",
    genericError: "Something went wrong. Please try again.",
    authWrongPassword: "Incorrect password.",
    authUserNotFound: "No account found with this email.",
    authEmailAlreadyInUse: "This email is already in use.",
    authWeakPassword: "Password is too weak. Use at least 6 characters.",
    authTooManyRequests: "Too many attempts. Please try again later.",
    authPopupClosed: "Sign-in was cancelled.",
    authAccountExistsDifferentProvider: "This email is linked to Google. Sign in with Google.",
    authInvalidEmail: "Invalid email address.",
    authInvalidActionCode: "This link is invalid or has expired.",
    authNetworkError: "Network error. Check your connection.",
    authUserDisabled: "This account has been disabled.",
    authOperationNotAllowed: "This sign-in method is not available.",
    authCredentialAlreadyInUse: "These credentials are already in use.",
};

const loginLangs = { el, en };

export type LoginStrings = typeof el;

export function useLoginStrings(): LoginStrings {
    const [lang] = useContext(langContext);
    return loginLangs[lang];
}
